import {useFetchBuilderReference} from '@/builder/hooks/useFetchBuilderReference'
import modelMap from 'hec/builder/model-map'

const useFetchPageDataForCta = ({isInternalLink, pageReference, externalLinkReference}) => {
    // Add defensive checks and fallback logic for model resolution
    const getPageModel = () => {
        if (pageReference?.model) {
            return pageReference.model
        }
        // Fallback to default page model if not specified
        return modelMap.pageModel
    }

    const pageModel = getPageModel()
    const shouldQueryPageData =
        isInternalLink && !!pageReference?.id && !pageReference?.value?.data && !!pageModel
    const shouldQueryExternalLinkData =
        !isInternalLink && !!externalLinkReference?.id && !externalLinkReference?.value?.data

    // Log debug information for troubleshooting
    if (isInternalLink && pageReference?.id && !pageModel) {
        console.warn('useFetchPageDataForCta: Missing model for page reference', {
            pageReference,
            isInternalLink,
            availableModels: Object.keys(modelMap)
        })
    }

    const {
        data: pageData,
        isLoading: isPageDataLoading,
        error: pageDataError
    } = useFetchBuilderReference({
        model: pageModel,
        shouldQuery: shouldQueryPageData,
        referenceId: pageReference?.id,
        fields: 'data.isSfraPage,data.url,data.sfraUrl'
    })

    const {
        data: externalLinkData,
        isLoading: isExternalLinkDataLoading,
        error: externalLinkDataError
    } = useFetchBuilderReference({
        model: modelMap.externalLinks,
        shouldQuery: shouldQueryExternalLinkData,
        referenceId: externalLinkReference?.id,
        fields: 'data.url'
    })

    const isLoading =
        (shouldQueryPageData && isPageDataLoading) ||
        (shouldQueryExternalLinkData && isExternalLinkDataLoading)
    const error = pageDataError || externalLinkDataError

    // Enhanced error logging
    if (error) {
        console.error('Error fetching page data for CTA:', {
            error,
            pageDataError,
            externalLinkDataError,
            pageModel,
            pageReference,
            externalLinkReference,
            isInternalLink
        })
    }

    return {
        pageRef: pageReference?.value?.data || pageData?.data,
        externalLinkRef: externalLinkReference?.value?.data || externalLinkData?.data,
        isLoading,
        error
    }
}

export default useFetchPageDataForCta
